<template>
  <div>
    <component
      :is="`${parentItem.type}-menu-button`"
      :props="props"
      :item="parentItem"
      class="menu-item px-0"
      :class="`menu-item-${parentItem.id} ${props.class}`"
    ></component>

    <div class="submenu-items">
      <component
        v-for="item in item.children"
        :key="item.id"
        :is="`${item.type}-menu-button`"
        :props="props"
        :item="item"
        class="menu-item px-0"
        :class="`menu-item-${item.id} ${props.class}`"
      ></component>
    </div>
  </div>
</template>

<script>
import PageMenuButton from './PageMenuButton'
import SectionMenuButton from './SectionMenuButton'
import UrlMenuButton from './UrlMenuButton'
import FileMenuButton from './FileMenuButton'

export default {
  name: 'ParentVerticalMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMenuButton,
    SectionMenuButton,
    UrlMenuButton,
    FileMenuButton
  },
  computed: {
    parentItem() {
      const item = {
        ...this.item.children[0]
      }
      item.name = this.item.name

      return item
    }
  }
}
</script>

<style>
.v-menu__content,
.v-list {
  border-radius: 0 !important;
  z-index: 400 !important;
}
.row.text-start .submenu-items {
  margin-left: 20px;
}
.row.text-end .submenu-items {
  margin-right: 20px;
}
</style>

<style scoped>
.menu-item.px-0.menu-active-style-default.v-btn {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
</style>
